const APP_STORAGE_PREFIX = "as_"; //To identify keys in localStorage used by AppStorage
const APP_STORAGE_PREFIX_PERM = "asp_"; //To identify keys in localStorage used by AppStorage but not to be cleared by AppStorage.clear()
export class AppStorage {
  private static local = {
    setItem: (key: string, value: string | null, permanent?: boolean) =>
      localStorage.setItem(
        permanent ? APP_STORAGE_PREFIX_PERM + key : APP_STORAGE_PREFIX + key,
        JSON.stringify(value),
      ),
    getItem: <T>(key: string, permanent?: boolean) => {
      const value = localStorage.getItem(
        permanent ? APP_STORAGE_PREFIX_PERM + key : APP_STORAGE_PREFIX + key,
      );
      return value ? (JSON.parse(value) as T) : null;
    },
    removeItem: (key: string, permanent?: boolean) =>
      localStorage.removeItem(
        permanent ? APP_STORAGE_PREFIX_PERM + key : APP_STORAGE_PREFIX + key,
      ),
  };

  private static session = {
    setItem: (key: string, value: string | null) =>
      sessionStorage.setItem(APP_STORAGE_PREFIX + key, JSON.stringify(value)),
    getItem: <T>(key: string) => {
      const value = sessionStorage.getItem(APP_STORAGE_PREFIX + key);
      return value ? (JSON.parse(value) as T) : null;
    },
    removeItem: (key: string) =>
      sessionStorage.removeItem(APP_STORAGE_PREFIX + key),
  };

  static get currentOrgId(): string | null {
    return this.local.getItem<string>("currentOrgId", true);
  }
  static set currentOrgId(value: string | null) {
    this.local.setItem("currentOrgId", value, true);
  }

  static get workspace(): string | null {
    return this.local.getItem<string>("workspace");
  }
  static set workspace(value: string | null) {
    if (value === null) {
      this.local.removeItem("workspace");
    } else this.local.setItem("workspace", value);
  }

  static get noOrgVisited(): string | null {
    return this.local.getItem<string>("noOrgVisited");
  }
  static set noOrgVisited(value: string | null) {
    if (value === null) {
      this.local.removeItem("noOrgVisited");
    } else this.local.setItem("noOrgVisited", value);
  }

  static get sessionId(): string {
    let sessionId = this.session.getItem<string>("sessionId");
    if (!sessionId) {
      sessionId = crypto.randomUUID();
      this.session.setItem("sessionId", sessionId);
    }
    return sessionId;
  }

  static get deviceId(): string {
    let deviceId = this.local.getItem<string>("deviceId", true);
    if (!deviceId) {
      deviceId = crypto.randomUUID();
      this.local.setItem("deviceId", deviceId, true);
    }
    return deviceId;
  }

  static get previousPath(): string | null {
    return this.session.getItem<string>("previousPath");
  }
  static set previousPath(value: string | null) {
    this.session.setItem("previousPath", value);
  }

  static getCurrentPath(): string {
    return (
      window.location.pathname + window.location.search + window.location.hash
    );
  }

  static get serverTimingMinified(): boolean {
    return this.local.getItem<string>("serverTimingMinified", true) === "true";
  }
  static set serverTimingMinified(value: boolean) {
    this.local.setItem("serverTimingMinified", value ? "true" : null, true);
  }

  static onCurrentOrgIdChange(
    callback: (newOrgId: string | null) => void,
  ): () => void {
    const handler = (event: StorageEvent) => {
      if (
        event.storageArea !== localStorage ||
        event.key !== APP_STORAGE_PREFIX_PERM + "currentOrgId"
      )
        return;
      callback(AppStorage.currentOrgId);
    };
    window.addEventListener("storage", handler);
    return () => window.removeEventListener("storage", handler);
  }

  static clear() {
    for (const key in localStorage) {
      if (key.startsWith(APP_STORAGE_PREFIX)) {
        localStorage.removeItem(key);
      }
    }
  }
}
